import { render, staticRenderFns } from "./LoanDatesBox.vue?vue&type=template&id=1120cc42&scoped=true"
import script from "./LoanDatesBox.vue?vue&type=script&lang=js"
export * from "./LoanDatesBox.vue?vue&type=script&lang=js"
import style0 from "./LoanDatesBox.vue?vue&type=style&index=0&id=1120cc42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1120cc42",
  null
  
)

export default component.exports